export default class AgGridSubtitleCellRenderer {
  eGui;
  eGroupStatus;
  eValueContainer;

  node;

  init(params) {
    this.node = params.node;
    this.eGui = document.createElement('div');
    this.eGui.setAttribute('style', `display: flex`);

    if (this.node.group) {
      if (!params?.value) {
        return;
      }

      this.eValueContainer = document.createElement('span');
      this.eValueContainer.setAttribute('class', 'eValueContainer');
      this.eGui.appendChild(this.eValueContainer);

      const res = params?.getHeaderValues(params);
      if(res.subtitle && res.chipValue){
        this.eValueContainer.innerHTML = `
        <div class="custom-group-column">
          <div class="title-container">
            <div class="title">${res.title}</div>
            <div class="sub-title">${res.subtitle}</div>
          </div>
          <div class="chip-container">
              <status-chip></status-chip>
            </div>
        </div>`;

        const statusChip = this.eGui.querySelector('status-chip');
        statusChip.statusValue = res.chipValue; //controls color
        statusChip.innerHTML = res.chipValue
        statusChip.statusClasses= {
          Pending: "",
          Submitted: 'info',
          Approved: 'success',
          Rejected: 'error',
        };
      }
      else if(res.subtitle){
        this.eValueContainer.innerHTML = `
        <div class="custom-group-column">
        <div class="title-container">
          <div class="title">${res.title}</div>
          <div class="sub-title">${res.subtitle}</div>
        </div>
        </div>`;
      }
      else{
        this.eValueContainer.innerHTML = `
             <div class="title">${res.title || "-"}</div>`;
      }
      
    }
  }

  getGui() {
    return this.eGui;
  }

  refresh() {
    return false;
  }

  destroy() {
  }
}
